import { render } from "./FaqListPage.vue?vue&type=template&id=278b8ae2&lang=true"
import script from "./FaqListPage.vue?vue&type=script&lang=js"
export * from "./FaqListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__